{
  "basicFormElements": {
    "formRows": [
         {
        "formGroups": [
          {
            "style": { "gridColumn": "span 2" },
            "control": {
              "label": "locationType",
              "displayLabel": "Location Type",
              "fieldInfo": {
                "dataType": "multi-select",
                "options":[
                  { "label": "Port", "value": "PORT"},
                  {
                    "label": "Inland Container Depot",
                    "value": "INLAND_CONTAINER_DEPOT"
                  },
                  { "label": "CFS", "value": "CFS" },
                  {
                    "label": "Empty Depot",
                    "value": "EMPTY_DEPOT"
                  },
                  {
                    "label": "Berthing Point",
                    "value": "BERTHING_POINT"
                  },
                  {
                    "label": "Port Terminal",
                    "value": "PORT_TERMINAL"
                  },
                  {
                    "label": "Repairing Yard",
                    "value": "REPAIRING_YARD"
                  }
                ]
              },
              "validators": [
                {
                  "type": "required",
                  "message": "At least one customer type must be selected"
                }
              ]
            }
          },
          {
            "style": { "gridColumn": "span 2" },
            "control": {
              "label": "panNumber",
              "displayLabel": "PAN Number",
              "placeHolder": "Enter PAN Number",
              "validators": [
                { "type": "required", "message": "PAN Number is required" }
              ],
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "style": { "gridColumn": "span 2" },
            "control": {
              "label": "name",
              "displayLabel": "Location Name",
              "placeHolder": "Enter name",
              "validators": [
                { "type": "required", "message": "Name is required" }
              ],
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "style": { "gridColumn": "span 2" },
            "control": {
              "label": "distanceFromCFS",
              "displayLabel": "Distance from CFS (in KM)",
              "placeHolder": "Enter distance in km (optional)",
              "fieldInfo": { "dataType": "number" }
            }
          }
        ]
      }
    ]
  },



  "contactInformationFormElements": {
    "formRows": [
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 4" },

            "control": {
              "label": "addressLine1",
              "displayLabel": "Address Line 1",
              "placeHolder": "Enter Address Line 1",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "style": { "gridColumn": "span 4" },

            "control": {
              "label": "addressLine2",
              "displayLabel": "Address Line 2",
              "placeHolder": "Enter Address Line 2",
              "fieldInfo": { "dataType": "text" }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 4" },

            "control": {
              "label": "cityId",
              "displayLabel": "City",
              "placeHolder": "Enter City",
              "returnRawValue" : true,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/cities/list",                  
                  "filterByKeys": ["NAME_CONTAINS"],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "operator": "EQ",
                      "value": ["true"]
                    }
                  ],
                  "displayColumns": [
                    { "key": "name", "header": "Name" },
                    { "key": "code", "header": "Code" }
                  ]
                }
              }
            }
          },
          {
            "style": { "gridColumn": "span 4" },
            "control": {
              "label": "stateId",
              "displayLabel": "State",
              "placeHolder": "Enter State",
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/states/list",
                  "selectFields": ["id", "name"],
                  "filterByKeys": ["name"],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "additionalFilters": [
                    {
                      "name": "active",
                      "alias": "active",
                      "operator": "EQ",
                      "value": ["true"]
                    }
                  ],
                  "displayColumns": [
                    { "key": "name", "header": "Name" }
                  ]
                }
              }
            }
          },
          {
            "style": { "gridColumn": "span 4" },
            "control": {
              "label": "country",
              "displayLabel": "Country",
              "placeHolder": "Enter Country",
              "returnRawValue" : false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/countries/list",
                  "filterByKeys": ["NAME_CONTAINS"],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "additionalFilters": [
                    {
                      "name": "active",
                      "alias": "active",
                      "operator": "EQ",
                      "value": ["true"]
                    }
                  ],
                  "displayColumns": [
                    { "key": "name", "header": "Name" }
                  ]
                }
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "pinCode",
              "displayLabel": "Postal Code",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "control": {
              "label": "email",
              "displayLabel": "Email",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "control": {
              "label": "mobileNumber1",
              "displayLabel": "Mobile Number",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "control": {
              "label": "mobileNumber2",
              "displayLabel": "Alternative Mobile Number",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "control": {
              "label": "defaultContact",
              "displayLabel": "Default Contact",
              "placeHolder": "Select Default Contact",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  { "label": "Yes", "value": true },
                  { "label": "No", "value": false }
                ]
              }
            }
          },

          {
            "control": {
              "label": "communicationPreference",
              "displayLabel": "Communication Preference",
              "placeHolder": "Select Preference",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  { "label": "Mobile Phone", "value": "mobile" },
                  { "label": "Email", "value": "email" }
                ]
              }
            }
          }
        ]
      }
    ]
  },

  "personFormElements": {
    "formRows": [
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 4" },

            "control": {
              "label": "name",
              "displayLabel": "Person's Name",
              "placeHolder": "Enter person's name",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "style": { "gridColumn": "span 4" },

            "control": {
              "label": "designation",
              "displayLabel": "Designation",
              "placeHolder": "Enter designation",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "style": { "gridColumn": "span 4" },

            "control": {
              "label": "email",
              "displayLabel": "Email",
              "placeHolder": "Enter email",
              "fieldInfo": { "dataType": "email" }
            }
          },
          {
            "control": {
              "label": "mobileNumber1",
              "displayLabel": "Mobile Number",
              "placeHolder": "Enter mobile number",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "style": { "gridColumn": "span 4" },

            "control": {
              "label": "mobileNumber2",
              "displayLabel": "Alternative Mobile Number",
              "placeHolder": "Enter alternative mobile number",
              "fieldInfo": { "dataType": "text" }
            }
          },
          {
            "control": {
              "label": "communicationPreference",
              "displayLabel": "Communication Preference",
              "placeHolder": "Select Preference",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  { "label": "Mobile Phone", "value": "mobile" },
                  { "label": "Email", "value": "email" }
                ]
              }
            }
          }
        ]
      }
    ]
  }
}
